module.exports = __webpack_public_path__ + "static/10-bc932d747e2d76f47dce619c7f72e0ef.png";